<template>
  <div class="wrapper">
    <el-dialog
      :close-on-click-modal="visible"
      :title="title"
      :visible.sync="visible"
      width="50%"
      @close="close"
    >
      <el-form
        :model="form"
        ref="form"
        :rules="validatorRules"
        size="small"
        label-width="120px"
      >
        <el-form-item label="权限名称" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="权限资源路径" prop="url">
          <el-input v-model="form.url"></el-input>
        </el-form-item>
        <el-form-item label="权限编码" prop="code">
          <el-input v-model="form.code"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="seq">
          <el-input v-model="form.seq"></el-input>
        </el-form-item>
        <el-form-item label="权限资源描述">
          <el-input v-model="form.description"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="close">取 消</el-button>
        <el-button size="small" type="primary" @click="handleOk"
          >保 存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { httpAction } from "@/api/manage";
// import { listMixin } from '@/mixins/listMixin';

var codeNumber = (rule, value, callback) => {
  if (value.length < 1) {
    callback(new Error("请输入code"));
  } else if (isNaN(value)) {
    callback(new Error("请输入整数"));
  }
  callback();
};
export default {
  components: {},
  // mixins: [listMixin],
  props: {},
  data() {
    return {
      title: "操作",
      visible: false,
      form: {},
      validatorRules: {
        name: [
          {
            required: true,
            message: "请输入权限名称",
            trigger: "blur",
          },
          {
            min: 1,
            max: 10,
            message: "长度在 1 到 10 个字符",
            trigger: "blur",
          },
        ],
        url: [
          {
            required: true,
            message: "请输入权限资源路径",
            trigger: "blur",
          },
        ],
        code: [
          {
            validator: codeNumber,
            required: true,
            trigger: "blur",
          },
        ],
        seq: [
            { required: true, message: '请输入数字', trigger: 'blur' },
            { pattern: /^[0-9]*$/, message: '只能输入数字', trigger: 'blur' }
          ]
      },
      url: {
        queryFoneRoleInfo: "/wlFontRole/queryFoneRoleInfo/",
        add: "/wlFontRole/saveFoneRole",
        edit: "/wlFontRole/updateFoneRole",
      },
    };
  },
  watch: {},
  computed: {},
  methods: {
    add() {
      this.edit({});
    },
    async edit(record) {
      console.log(record);
      this.visible = true;
      if (!record.id) return;
      let res = await httpAction(
        this.url.queryFoneRoleInfo + "?id=" + record.id,
        {},
        "get"
      );
      if (res.code == 200) {
        console.log(res);
        this.form = res.data;
        // this.form.id = res.data.id;
        // this.form.pcode = res.data.pcode;
        // this.form.typeCode = res.data.typeCode;
        // this.form.typeName = res.data.typeName;
      } else {
        this.$message.warning(res.msg);
      }
    },
    close() {
      this.visible = false;
      this.form = {};
      this.$refs.form.resetFields();
    },
    handleOk() {
      // 触发表单验证
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          console.log(this.form);
          if (this.title === "新增") {
            let res = await httpAction(this.url.add, this.form, "post");
            if (res.code !== 200) return this.$message.error(res.msg);
            this.$message.success("操作成功");
            this.close();
            this.$emit("ok");
          } else if (this.title === "编辑") {
            let res = await httpAction(this.url.edit, this.form, "post");
            console.log(res);
            if (res.code == 200) {
              this.$message.success("操作成功");
              this.close();
              this.$emit("editOk");
            } else {
              this.$message.warning(res.msg);
            }
          }
        } else {
          return false;
        }
      });
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.wrapper {
  .menuBar {
    border: 1px solid #dcdfe6;
    border-radius: 8px;
    /*height: calc(100% - 100px);*/
    height: 300px;
    overflow-y: auto;
  }
}
</style>
